// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SavedContentDetail-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 100px; /* Navbar height */
  background-color: var(--background);
  color: var(--text-primary);
  z-index: 9999999;
  /* padding: 8px; */
  height: calc(100vh - 5.5rem);
  /* margin-top: 3rem; */
}

.SavedContentDetail-card {
  background-color: var(--background);
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  margin: 0 auto;
  max-width: 90%;
  padding: 40px;
  height: calc(100vh - 210px);
  width: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
  top: 1rem;
}

/* Hide scrollbar but keep functionality */
.SavedContentDetail-card::-webkit-scrollbar {
  display: none;
}

/* Ensure content at bottom has enough padding to be visible */
.SavedContentDetail-card > *:last-child {
  margin-bottom: 4rem;
}

.SavedMedia-runtime-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.SavedMedia-runtime-container p {
  margin-left: 8px;
  margin-bottom: 0;
}

.SavedContentDetail-card h2 {
  font-size: 2.25rem;
  margin: 50px 0px 0px 0px;
  width: 75%;
}

.SavedContentDetail-card h5 {
  font-size: 1.8rem;
  margin-bottom: 20px;
  font-weight: bold;
  text-transform: uppercase;
}

.SavedContentDetailPoster {
  width: 100%;
  max-height: 600px;
  object-fit: contain;
  margin-bottom: 40px;
  border-radius: 5px;
}

.SavedContentDetail-card p,
.SavedContentDetail-card h6 {
  font-size: 1.2rem;
  line-height: 1.6;
  margin-bottom: 20px;
}

.SavedContentDetail-card ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.SavedContentDetail-card li {
  display: inline;
  margin-right: 8px;
}

.SavedContentDetail-card a {
  font-weight: bold;
  font-size: 1.2rem;
  text-decoration: none;
  color: #fff;
  transition: color 0.2s;
}

.SavedContentDetail-card a:hover {
  color: #e50914;
}

.SavedContentSocialMedia {
  margin-top: 40px;
}

.SavedContentSocialMedia svg {
  color: #fff;
  cursor: pointer;
  margin-right: 20px;
  transition: color 0.2s;
}

.SavedContentSocialMedia svg:hover {
  color: #e50914;
}

.SavedProviders-section {
  margin-bottom: 32px;
}

.SavedProviders-section h4 {
  font-size: 2rem;
  margin-bottom: 20px;
  text-transform: uppercase;
}

.SavedProvider-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
  gap: 20px;
}

.SavedProvider-logo {
  max-height: 65px;
  object-fit: contain;
  box-sizing: border-box;
  display: block;
  margin-left: auto;
  margin-right: auto;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  transition: transform 0.2s;
}

.SavedProvider-logo:hover {
  transform: scale(1.1);
}

.SavedProvider-item {
  display: inline-grid;
  text-align: center;
  margin: 6px;
}

.SavedType-info {
  margin-top: 4px;
}

.SavedType-label {
  display: block;
}

.SavedSocial-icon {
  font-size: 2em;
  color: var(--text-primary);
  padding: 4px;
}

.SavedClose-container {
  position: fixed;
  top: 1.5rem;
  right: 2.5rem;
  font-size: 1.5rem;
}

.SavedSocial-media-container {
  position: absolute;
  top: 16px;
  left: 16px;
  display: flex;
  align-items: center;
}

.SavedType-amount {
  font-size: 0.8em;
}

/* Mobile */
@media only screen and (max-width: 767px) {
  .SavedContentDetail-card {
    padding: 20px;
    /* margin-bottom: 48px */
  }

  .SavedContentDetailPoster {
    max-height: 360px;
    margin-bottom: 20px;
  }

  .SavedContentDetail-card h2 {
    font-size: 1.8rem;
    margin-bottom: 10px;
  }

  .SavedContentDetail-card h5 {
    font-size: 1.4rem;
    margin-bottom: 16px;
  }

  .SavedContentDetail-card p,
  .SavedContentDetail-card h6 {
    font-size: 1rem;
    line-height: 1.4;
    margin-bottom: 16px;
  }

  .SavedProviders-section h4 {
    font-size: 1rem;
    margin-bottom: 16px;
  }

  .SavedProvider-container {
    grid-template-columns: repeat(auto-fit, minmax(60px, 1fr));
    gap: 10px;
  }

  .SavedProvider-logo {
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    border-radius: 3px;
    transition: transform 0.2s;
  }

  .SavedProvider-logo:hover {
    transform: scale(1.05);
  }
}

.savedContentDetail-credits-container {
  padding-top: 50px;
  text-align: center;
  color: white;
}

.savedContentDetail-credits-container .justwatch-logo {
  width: 100px;
  margin-bottom: 60px;
}

/* Tablet */
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .SavedContentDetail-card {
    max-width: 700px;
    /* margin-bottom: 100px */
  }

  .SavedContentDetailPoster {
    max-height: 420px;
    margin-bottom: 30px;
  }

  .SavedContentDetail-card h2 {
    font-size: 2rem;
    margin-bottom: 12px;
  }

  .SavedContentDetail-card h5 {
    font-size: 1.6rem;
    margin-bottom: 18px;
  }

  .SavedContentDetail-card p,
  .SavedContentDetail-card h6 {
    font-size: 1.1rem;
    line-height: 1.5;
    margin-bottom: 18px;
  }

  .SavedProviders-section h4 {
    font-size: 1.8rem;
    margin-bottom: 18px;
  }

  .SavedProvider-container {
    grid-template-columns: repeat(auto-fit, minmax(70px, 1fr));
    gap: 15px;
  }

  .SavedProvider-logo {
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    transition: transform 0.2s;
  }

  .SavedProvider-logo:hover {
    transform: scale(1.07);
  }
}

/* Desktop */
@media only screen and (min-width: 1024px) {
  .SavedContentDetail-container {
    padding: 60px 0;
  }

  .SavedContentDetail-card {
    max-width: 900px;
    /* margin-bottom: 100px */
  }

  .SavedContentDetailPoster {
    max-height: 600px;
    margin-bottom: 40px;
  }

  .SavedContentDetail-card h2 {
    font-size: 2.5rem;
    margin-bottom: 14px;
  }

  .SavedContentDetail-card h5 {
    font-size: 1.8rem;
    margin-bottom: 20px;
  }

  .SavedContentDetail-card p,
  .SavedContentDetail-card h6 {
    font-size: 1
    2rem;
    line-height: 1.6;
    margin-bottom: 20px;
  }

  .SavedContentSocialMedia {
    margin-top: 60px;
  }

  .SavedContentSocialMedia svg {
    font-size: 3em;
    margin-right: 30px;
  }

  .SavedProviders-section h4 {
    font-size: 2.5rem;
    margin-bottom: 30px;
  }

  .SavedProvider-logo {
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.7);
    border-radius: 10px;
    transition: transform 0.2s;
  }

  .SavedProvider-logo:hover {
    transform: scale(1.15);
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/SavedContentDetail.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa,EAAE,kBAAkB;EACjC,mCAAmC;EACnC,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;EACd,cAAc;EACd,aAAa;EACb,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,SAAS;AACX;;AAEA,0CAA0C;AAC1C;EACE,aAAa;AACf;;AAEA,8DAA8D;AAC9D;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE;IACE,aAAa;IACb,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,0DAA0D;IAC1D,SAAS;EACX;;EAEA;IACE,sCAAsC;IACtC,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;IAEE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,0DAA0D;IAC1D,SAAS;EACX;;EAEA;IACE,sCAAsC;IACtC,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,YAAY;AACZ;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;IAEE;QACI;IACJ,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,uCAAuC;IACvC,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".SavedContentDetail-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 100px; /* Navbar height */\n  background-color: var(--background);\n  color: var(--text-primary);\n  z-index: 9999999;\n  /* padding: 8px; */\n  height: calc(100vh - 5.5rem);\n  /* margin-top: 3rem; */\n}\n\n.SavedContentDetail-card {\n  background-color: var(--background);\n  border-radius: 5px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n  margin: 0 auto;\n  max-width: 90%;\n  padding: 40px;\n  height: calc(100vh - 210px);\n  width: 100%;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  position: relative;\n  top: 1rem;\n}\n\n/* Hide scrollbar but keep functionality */\n.SavedContentDetail-card::-webkit-scrollbar {\n  display: none;\n}\n\n/* Ensure content at bottom has enough padding to be visible */\n.SavedContentDetail-card > *:last-child {\n  margin-bottom: 4rem;\n}\n\n.SavedMedia-runtime-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.SavedMedia-runtime-container p {\n  margin-left: 8px;\n  margin-bottom: 0;\n}\n\n.SavedContentDetail-card h2 {\n  font-size: 2.25rem;\n  margin: 50px 0px 0px 0px;\n  width: 75%;\n}\n\n.SavedContentDetail-card h5 {\n  font-size: 1.8rem;\n  margin-bottom: 20px;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.SavedContentDetailPoster {\n  width: 100%;\n  max-height: 600px;\n  object-fit: contain;\n  margin-bottom: 40px;\n  border-radius: 5px;\n}\n\n.SavedContentDetail-card p,\n.SavedContentDetail-card h6 {\n  font-size: 1.2rem;\n  line-height: 1.6;\n  margin-bottom: 20px;\n}\n\n.SavedContentDetail-card ul {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\n.SavedContentDetail-card li {\n  display: inline;\n  margin-right: 8px;\n}\n\n.SavedContentDetail-card a {\n  font-weight: bold;\n  font-size: 1.2rem;\n  text-decoration: none;\n  color: #fff;\n  transition: color 0.2s;\n}\n\n.SavedContentDetail-card a:hover {\n  color: #e50914;\n}\n\n.SavedContentSocialMedia {\n  margin-top: 40px;\n}\n\n.SavedContentSocialMedia svg {\n  color: #fff;\n  cursor: pointer;\n  margin-right: 20px;\n  transition: color 0.2s;\n}\n\n.SavedContentSocialMedia svg:hover {\n  color: #e50914;\n}\n\n.SavedProviders-section {\n  margin-bottom: 32px;\n}\n\n.SavedProviders-section h4 {\n  font-size: 2rem;\n  margin-bottom: 20px;\n  text-transform: uppercase;\n}\n\n.SavedProvider-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));\n  gap: 20px;\n}\n\n.SavedProvider-logo {\n  max-height: 65px;\n  object-fit: contain;\n  box-sizing: border-box;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n  border-radius: 5px;\n  transition: transform 0.2s;\n}\n\n.SavedProvider-logo:hover {\n  transform: scale(1.1);\n}\n\n.SavedProvider-item {\n  display: inline-grid;\n  text-align: center;\n  margin: 6px;\n}\n\n.SavedType-info {\n  margin-top: 4px;\n}\n\n.SavedType-label {\n  display: block;\n}\n\n.SavedSocial-icon {\n  font-size: 2em;\n  color: var(--text-primary);\n  padding: 4px;\n}\n\n.SavedClose-container {\n  position: fixed;\n  top: 1.5rem;\n  right: 2.5rem;\n  font-size: 1.5rem;\n}\n\n.SavedSocial-media-container {\n  position: absolute;\n  top: 16px;\n  left: 16px;\n  display: flex;\n  align-items: center;\n}\n\n.SavedType-amount {\n  font-size: 0.8em;\n}\n\n/* Mobile */\n@media only screen and (max-width: 767px) {\n  .SavedContentDetail-card {\n    padding: 20px;\n    /* margin-bottom: 48px */\n  }\n\n  .SavedContentDetailPoster {\n    max-height: 360px;\n    margin-bottom: 20px;\n  }\n\n  .SavedContentDetail-card h2 {\n    font-size: 1.8rem;\n    margin-bottom: 10px;\n  }\n\n  .SavedContentDetail-card h5 {\n    font-size: 1.4rem;\n    margin-bottom: 16px;\n  }\n\n  .SavedContentDetail-card p,\n  .SavedContentDetail-card h6 {\n    font-size: 1rem;\n    line-height: 1.4;\n    margin-bottom: 16px;\n  }\n\n  .SavedProviders-section h4 {\n    font-size: 1rem;\n    margin-bottom: 16px;\n  }\n\n  .SavedProvider-container {\n    grid-template-columns: repeat(auto-fit, minmax(60px, 1fr));\n    gap: 10px;\n  }\n\n  .SavedProvider-logo {\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n    border-radius: 3px;\n    transition: transform 0.2s;\n  }\n\n  .SavedProvider-logo:hover {\n    transform: scale(1.05);\n  }\n}\n\n.savedContentDetail-credits-container {\n  padding-top: 50px;\n  text-align: center;\n  color: white;\n}\n\n.savedContentDetail-credits-container .justwatch-logo {\n  width: 100px;\n  margin-bottom: 60px;\n}\n\n/* Tablet */\n@media only screen and (min-width: 768px) and (max-width: 1023px) {\n  .SavedContentDetail-card {\n    max-width: 700px;\n    /* margin-bottom: 100px */\n  }\n\n  .SavedContentDetailPoster {\n    max-height: 420px;\n    margin-bottom: 30px;\n  }\n\n  .SavedContentDetail-card h2 {\n    font-size: 2rem;\n    margin-bottom: 12px;\n  }\n\n  .SavedContentDetail-card h5 {\n    font-size: 1.6rem;\n    margin-bottom: 18px;\n  }\n\n  .SavedContentDetail-card p,\n  .SavedContentDetail-card h6 {\n    font-size: 1.1rem;\n    line-height: 1.5;\n    margin-bottom: 18px;\n  }\n\n  .SavedProviders-section h4 {\n    font-size: 1.8rem;\n    margin-bottom: 18px;\n  }\n\n  .SavedProvider-container {\n    grid-template-columns: repeat(auto-fit, minmax(70px, 1fr));\n    gap: 15px;\n  }\n\n  .SavedProvider-logo {\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);\n    border-radius: 4px;\n    transition: transform 0.2s;\n  }\n\n  .SavedProvider-logo:hover {\n    transform: scale(1.07);\n  }\n}\n\n/* Desktop */\n@media only screen and (min-width: 1024px) {\n  .SavedContentDetail-container {\n    padding: 60px 0;\n  }\n\n  .SavedContentDetail-card {\n    max-width: 900px;\n    /* margin-bottom: 100px */\n  }\n\n  .SavedContentDetailPoster {\n    max-height: 600px;\n    margin-bottom: 40px;\n  }\n\n  .SavedContentDetail-card h2 {\n    font-size: 2.5rem;\n    margin-bottom: 14px;\n  }\n\n  .SavedContentDetail-card h5 {\n    font-size: 1.8rem;\n    margin-bottom: 20px;\n  }\n\n  .SavedContentDetail-card p,\n  .SavedContentDetail-card h6 {\n    font-size: 1\n    2rem;\n    line-height: 1.6;\n    margin-bottom: 20px;\n  }\n\n  .SavedContentSocialMedia {\n    margin-top: 60px;\n  }\n\n  .SavedContentSocialMedia svg {\n    font-size: 3em;\n    margin-right: 30px;\n  }\n\n  .SavedProviders-section h4 {\n    font-size: 2.5rem;\n    margin-bottom: 30px;\n  }\n\n  .SavedProvider-logo {\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.7);\n    border-radius: 10px;\n    transition: transform 0.2s;\n  }\n\n  .SavedProvider-logo:hover {\n    transform: scale(1.15);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
